import { Link } from '@tanstack/react-router';
import { LuExternalLink } from 'react-icons/lu';

/**
 * データなし時に表示する「データを登録」ボタン。売上管理（売上票登録）へ遷移する。
 */
export default function SalesRegisterButton() {
  return (
    <Link
      to="/agent/profits"
      className="inline-flex shrink-0 items-center gap-xs rounded-sm border border-solid border-border bg-white px-md py-xs text-body-sm font-bold text-main hover:bg-gray-50"
    >
      データを登録
      <LuExternalLink className="size-4" />
    </Link>
  );
}
